// src/pages/AuthPage.tsx
import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext'; // Используем наш новый контекст
import '../App.css'; // Используем общие стили

function AuthPage() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const auth = useContext(AuthContext); // Получаем контекст аутентификации
    const navigate = useNavigate();

    const handleLogin = (e: React.FormEvent) => {
        e.preventDefault();
        setError('');

        if (username === 'user' && password === 'userpass') {
            // Имитация успешного входа
            auth?.login('fake-user-token', 'user', 'user');
            navigate('/dashboard'); // Перенаправляем на панель управления
        } else if (username === 'admin' && password === 'adminpass') {
            // Имитация успешного входа для администратора
            auth?.login('fake-admin-token', 'admin', 'admin');
            navigate('/dashboard'); // Перенаправляем на панель управления (или сразу в админку, если захотим)
        } else {
            setError('Неверное имя пользователя или пароль.');
        }
    };

    return (
        <div className="container">
            <div className="auth-card">
                <h2>Войти в систему</h2>
                <form onSubmit={handleLogin}>
                    <div className="input-group">
                        <label htmlFor="username">Имя пользователя:</label>
                        <input
                            type="text"
                            id="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </div>
                    <div className="input-group">
                        <label htmlFor="password">Пароль:</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    {error && <p className="error-message">{error}</p>}
                    <button type="submit" className="btn">Войти</button>
                </form>
            </div>
        </div>
    );
}

export default AuthPage;